import {
  App,
  EnvironmentVariables
} from '@partnerconnect-monorepo/types/EnvironmentVariables';

export const environment: EnvironmentVariables = {
  appName: App.Home,
  baseUrl: import.meta.env.VITE_REPORTING_APP_BE_BASE || '',
  publicUrl: import.meta.env.VITE_REACT_APP_PUBLIC_URL || '',
  environment: import.meta.env.VITE_REACT_APP_ENV || '',
  authUrl: import.meta.env.VITE_REACT_APP_AUTHENTICATION_URL || '',
  logoutUrl: import.meta.env.VITE_REACT_APP_LOGOUT_URL || '',
  authenticationClientId:
    import.meta.env.VITE_REACT_APP_AUTHENTICATION_CLIENT_ID || '',
  authRedirectUrl: import.meta.env.VITE_REACT_APP_CIAM_REDIRECT_URI || '',
  authLogoutRedirectUrl:
    import.meta.env.VITE_REACT_APP_CIAM_LOGOUT_REDIRECT || '',
  transifexToken: import.meta.env.VITE_REACT_APP_TRANSIFEX_TOKEN || '',
  sentryDsn: import.meta.env.VITE_REACT_APP_SENTRY_DSN || '',
  reactAppBaseRoute: import.meta.env.VITE_HOME_APP_BASE_ROUTE || '/',
  supportedLanguages: import.meta.env.VITE_REACT_APP_SUPPORTED_LANGUAGES || '',
  enablePartnershipsOverviewPage:
    import.meta.env.VITE_REACT_APP_ENABLE_PARTNERSHIPS_OVERVIEW_PAGE === 'true'
};
